import { Injectable } from '@angular/core';
import { Measure } from '@api-types/enums/measure.enum';

export interface ThresholdRange {
  // min value is INCLUSIVE
  min: number;
  // max value is EXCLUSIVE
  max: number;
  color: string;
}

type ThresholdConfig = Record<Measure, ThresholdRange[]>;

/**
 * note: since thresholds are not defined yet by data science team, we leave all empty for now
 * for testing you can you something like this:
 * { min: 0.1, max: 0.2, color: 'rgba(247, 187, 119, 0.1)' }, { min: 0.2, max: Infinity, color: 'rgba(247, 187, 119, 0.2)' }
 */
const MEASURE_THRESHOLDS: ThresholdConfig = {
  [Measure.Wape]: [],
  [Measure.Rae]: [],
  [Measure.Mase]: [],
  [Measure.Rrse]: [],
  [Measure.Smape]: [],
  [Measure.Mape]: [],
  [Measure.Mae]: [],
  [Measure.Rmse]: [],
  [Measure.Me]: [],
  [Measure.Wpe]: [],
  [Measure.Mpe]: [],
  [Measure.CappedWape]: [],
  [Measure.CappedMape]: [],
};

@Injectable({
  providedIn: 'root',
})
export class AnalysisThresholdService {
  getCellStyle(
    measure: Measure,
    value: number | null | undefined,
  ): { backgroundColor: string } | null {
    // == catches both null and undefined
    if (value == null) {
      return null;
    }

    const threshold = MEASURE_THRESHOLDS[measure]?.find(
      (t) => value >= t.min && value < t.max,
    );

    return threshold ? { backgroundColor: threshold.color } : null;
  }
}
